import { api } from '@/helpers/core'

export default {
	getBindings () {
		return api.get('/settings/bindings/')
	},
	updateBinding (binding) {
		return api.post('/settings/bindings/', binding)
	},
	deleteBinding (binding) {
		return api.post('/settings/bindings/delete', binding)
	},
	beginBindingTransaction () {
		return api.post('/settings/bindings/begin')
	},
	commitBindingTransaction (rootId) {
		return api.post('/settings/bindings/commit', { path: 'tx', rootId })
	},
	rollbackBindingTransaction (rootId) {
		return api.post('/settings/bindings/rollback', { path: 'tx', rootId })
	}
}
